import type { IndustryTaxonomyIndex } from "app/pages/sales-intelligence/domain/industry/types/taxonomy";

import useIndustryTaxonomyQuery from "../queries/useIndustryTaxonomyQuery";

import { useIsIndustryTaxonomyOptedIn } from "./useIsIndustryTaxonomyOptedIn";

/**
 * The taxonomy index for surfaces that only need it to *name* nodes — read-only displays outside the
 * filter panel. `undefined` while it loads, and permanently for accounts without the opt-in, which
 * cannot hold a taxonomy value in the first place.
 *
 * Gating the fetch here rather than at each call site keeps "only opted-in accounts fetch the tree" a
 * single rule; a rule re-implemented per consumer is one each new consumer can forget (ADR-0013).
 */
export const useOptedInIndustryTaxonomy = (): IndustryTaxonomyIndex | undefined => {
    const isIndustryTaxonomyOptedIn = useIsIndustryTaxonomyOptedIn();
    const { data } = useIndustryTaxonomyQuery({ enabled: isIndustryTaxonomyOptedIn });

    return data;
};
